module.exports = function (Constructor, list) {
  var index = 0;
  var length = list.length;
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/array-from-constructor-and-list.js